import { userGuard } from '~/router/middleware/guards'
import InvoicesList from '~/components/pages/document-flow/InvoicesList.vue'
import InvoicesCreate from '~/components/pages/document-flow/InvoicesCreate.vue'
import InvoicesEdit from '~/components/pages/document-flow/InvoicesEdit.vue'
import WorkloadsList from '~/components/pages/document-flow/WorkloadsList.vue'

export default [
  {
    path: '/document-flow/invoices',
    name: 'document-flow.invoices.list',
    component: InvoicesList,
    meta: {
      middleware: {
        permissions: ['statiz.document-flow.invoices.list'],
      },
    },
    beforeEnter: userGuard,
  },
  {
    path: '/document-flow/invoices/create',
    name: 'document-flow.invoices.create',
    component: InvoicesCreate,
    meta: {
      middleware: {
        permissions: ['statiz.document-flow.invoices.create'],
      },
    },
    beforeEnter: userGuard,
  },
  {
    path: '/document-flow/invoices/:id/edit',
    name: 'document-flow.invoices.edit',
    component: InvoicesEdit,
    meta: {
      middleware: {
        permissions: ['statiz.document-flow.invoices.edit'],
      },
    },
    beforeEnter: userGuard,
  },
  {
    path: '/document-flow/workloads',
    name: 'document-flow.workloads.list',
    component: WorkloadsList,
    meta: {
      middleware: {
        permissions: ['statiz.document-flow.workloads.list'],
      },
    },
    beforeEnter: userGuard,
  },
]
